export const RouteConstants = {
  Areas: {
    ListMaintenance: 'ListMaintenance'
  }
};
